import { ReactNode } from 'react';
import { Container, Portal, Stack } from '@optimus-web/core';

const PAGE_HEADER_ACTIONS_PORTAL_ID = 'page-header-actions-portal';

/**
 * @description Pass this element to the actions prop of the PageHeader
 */
export const PageHeaderActionElement = () => <Container id={PAGE_HEADER_ACTIONS_PORTAL_ID} />;

/**
 * @description This component is useful for situations where we have
 * the PageLayout, FilterSidebarLayout, etc on a _layout route, but need
 * to dynamically render different actions depending on the page. All you
 * need to do is wrap actions in this component.
 *
 * @example
 * <>
 * <PageHeaderActionsPortal>
 *     <GuideLinkButton guideLink={createGuideLink(ArticlePath.Route)} />
 * </PageHeaderActionsPortal>
 * <RouteContent />
 * </>
 */
export const PageHeaderActionsPortal = ({ children }: { children: ReactNode }) => (
    <Portal containerId={PAGE_HEADER_ACTIONS_PORTAL_ID}>
        <Stack spacing="100">{children}</Stack>
    </Portal>
);
